module.exports = "<div class=\"mbol-popup-wrapper\">\n  <lfwms-result-data-table [searchService]=\"lookupSearchService\" [popupMode]=\"true\">\n  </lfwms-result-data-table>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/mbol-error-log-popup/mbol-error-log-popup.component.html
// module id = ../../../../../src/app/shared/lookup/mbol-error-log-popup/mbol-error-log-popup.component.html
// module chunks = main